import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, Button, ButtonToolbar, Modal, Nav, NavItem} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, nodeIsValid} from '../../core/redux/form'
import delay from '../../core/redux/delay'
import {uiState, setUIState} from '../../core/redux/ui'
import {connectWizard} from '../../core/wizard'
import phonez from '../../core/phonez'
import Icon from '../../core/components/Icon'
import LoaderButton from '../../core/components/LoaderButton'
import {
    OPEN_TICKET_CMD_UPDATED,
    resetOpenTicketCmd,
    sendOpenTicketCmd,
    queryTicketStream,
    sendSimplifiedRequestQualified,
    fetchDocumentsForOpenTicket,
} from '../actions'
import {createValidator, OpenTicketCmd} from '../models'
import i18n from '../i18n'
import OpenTicketStreamCardLayout from './OpenTicketStreamCardLayout'
import OpenTicketAddressCard from './OpenTicketAddressCard'
import PhotoPreview from './PhotoPreview'
import OpenTicketCallerCard from './OpenTicketCallerCard'
import OpenTicketContactToCallbackCard from './OpenTicketContactToCallbackCard'
import OpenTicketPurposeCard from './OpenTicketPurposeCard'
import OpenTicketRequestCard from './OpenTicketRequestCard'
import OpenTicketCompanyModal from './OpenTicketCompanyModal'
import ReceiveCallModal from './ReceiveCallModal'
import style from './OpenTicketModal.less'

const COMPONENT_NAME = 'Ticket/OpenTicketModal'

function stepIsValid(form, step) {
    switch(step) {
        case 0: return nodeIsValid(form.company)
        case 1: return nodeIsValid(form.locationRef, form.ticket.address, form.ticket.callerz)
        case 2: return nodeIsValid(form.ticket.contactToCallback)
        case 3: return nodeIsValid(form.ticket.openingTicketPurpose, form.ticket.request, form.ticket.instructions, form.acknowledgeInstruction)
    }
}

function previousStepsAreValid(form, step) {
    var valid = true

    switch(step) {
        case 3: valid = valid && stepIsValid(form, 3)
        case 2: valid = valid && stepIsValid(form, 2)
        case 1: valid = valid && stepIsValid(form, 1)
        case 0: valid = valid && stepIsValid(form, 0)
    }

    return valid
}

class OpenTicketModal extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch, ui, cmd} = this.props

        const {opened} = uiState(COMPONENT_NAME, ui)

        if (opened && !(cmd && cmd.skipActor)) {
            dispatch(resetOpenTicketCmd())
        }
        if (opened && cmd && cmd.requestUid) {
            dispatch(fetchDocumentsForOpenTicket())
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ui != this.props.ui) {
            const nextOpened = uiState(COMPONENT_NAME, nextProps.ui).opened
            const opened = uiState(COMPONENT_NAME, this.props.ui).opened

            if (nextOpened != opened) {
                const {dispatch} = nextProps

                if (nextOpened) {
                    dispatch(resetOpenTicketCmd())
                }
            }
        }
    }

    _sendCmd = () => {
        const {dispatch, cmd} = this.props
        const {requestUid} = cmd

        return dispatch(sendOpenTicketCmd()).then((action) => {
            const ticketId = action.events.find((e) => e.eventType == 'TicketOpened').aggregateUid

            dispatch(setUIState(COMPONENT_NAME, {opened: false}))
            dispatch(push('/tickets/' + ticketId))

            return sendSimplifiedRequestQualified(requestUid, ticketId)
                .then(() => {}, () => {})
                .then (() => {
                    return dispatch(delay(queryTicketStream()))
                })
        })
    }

    _close = () => {
        const {dispatch} = this.props
        dispatch(setUIState(COMPONENT_NAME, {opened: false}))
    }

    _openReceiveCallModal(event, activeCaller, activeTicket) {
        event.preventDefault()

        const openedModal = 'ReceiveCallModal'
        this.setState({openedModal, activeCaller, activeTicket})
    }

    _openModal(openedModal) {
        this.setState({openedModal})
    }

    _closeModal = () => {
        this.setState({openedModal: null})
    }

    render() {
        const {dispatch, form, cmd, ui, stream, wizard, ...others} = this.props
        const {openedModal, activeCaller, activeTicket} = this.state

        const {opened} = uiState(COMPONENT_NAME, ui)

        const stepInfoGroupItemClassName = (step) => {
            return cx({
                [style.success]: stepIsValid(form, step),
                [style.active]: wizard.majorActiveStep == step,
                [style.disabled]: !previousStepsAreValid(form, step - 1)
            })
        }

        return (
            <div>
                <Modal
                    dialogClassName='modal-fullscreen'
                    show={opened}
                    onHide={this._close}
                    {...others}>
                    <Modal.Body>
                        <div className={style.header}>
                            <Nav justified
                                bsStyle='progress'
                                activeKey={wizard.majorActiveStep}
                                onSelect={(s) => wizard.setActiveStep(s)}>
                                {[1, 2, 3].map((step, index) => (
                                    <NavItem
                                        key={index}
                                        eventKey={step}
                                        className={cx({'nav-success': stepIsValid(form, step)})}
                                        disabled={!previousStepsAreValid(form, step - 1)}>
                                        {step}
                                    </NavItem>
                                ))}
                            </Nav>
                            <ul className={style.stepInfoGroup}>
                                <li className={stepInfoGroupItemClassName(1)}>
                                    {stepIsValid(form, 1) && (
                                        <h5>
                                            <Icon icon='check' size='xs' active={wizard.majorActiveStep == 1} />
                                            <span>{i18n.openTicketSteps.identify}</span>
                                            {cmd.ticket.callerz.namez && (
                                                <small>{cmd.ticket.callerz.namez.firstName} {cmd.ticket.callerz.namez.lastName}</small>
                                            )}
                                            {cmd.ticket.callerz.uid && cmd.ticket.callerz.uid.name && (
                                                <small>{cmd.ticket.callerz.uid.name.firstName} {cmd.ticket.callerz.uid.name.lastName}</small>
                                            )}
                                            <small>
                                                <span>{cmd.ticket.address.quality}</span>
                                                <span> {cmd.ticket.address.number} {cmd.ticket.address.street}</span>
                                                <span> {cmd.ticket.address.zipCode} {cmd.ticket.address.city}</span>
                                            </small>
                                        </h5>
                                    )}
                                    {!stepIsValid(form, 1) && (
                                        <h5>{i18n.openTicketSteps.identify}</h5>
                                    )}
                                </li>
                                <li className={stepInfoGroupItemClassName(2)}>
                                    {stepIsValid(form, 2) && (
                                        <h5>
                                            {cmd && cmd.ticket && cmd.ticket.contactToCallback && (
                                                <Icon icon='check' size='xs' active={wizard.majorActiveStep == 2} />
                                            )}
                                            <span>{i18n.openTicketSteps.contactToCallback}</span>
                                            {cmd && cmd.ticket && cmd.ticket.contactToCallback && (
                                                <small>
                                                    <span>{cmd.ticket.contactToCallback.namez}</span>
                                                    {cmd.ticket.contactToCallback.medium.phone && (
                                                        <span> ({phonez(cmd.ticket.contactToCallback.medium.phone).format()})</span>
                                                    )}
                                                    {cmd.ticket.contactToCallback.medium.mail && (
                                                        <span> ({cmd.ticket.contactToCallback.medium.mail})</span>
                                                    )}
                                                    {cmd.ticket.contactToCallback.medium.fax && (
                                                        <span> ({phonez(cmd.ticket.contactToCallback.medium.fax).format()})</span>
                                                    )}
                                                </small>
                                            )}
                                        </h5>
                                    )}
                                    {!stepIsValid(form, 2) && (
                                        <h5>{i18n.openTicketSteps.contactToCallback}</h5>
                                    )}
                                </li>
                                <li className={stepInfoGroupItemClassName(3)}>
                                    {stepIsValid(form, 3) && (
                                        <h5>
                                            <Icon icon='check' size='xs' active={wizard.majorActiveStep == 3} />
                                            <span>{i18n.openTicketSteps.request}</span>
                                            <small>{cmd.ticket.openingTicketPurpose.label}</small>
                                            <small>{cmd.ticket.request}</small>
                                        </h5>
                                    )}
                                    {!stepIsValid(form, 3) && (
                                        <h5>{i18n.openTicketSteps.request}</h5>
                                    )}
                                </li>
                            </ul>
                        </div>
                        <div className={style.main}>
                            <div className={cx(style.visibility, {[style.visible]: wizard.matchActiveStep(1)})}>
                                <Row>
                                    <Col sm={6}>
                                        <OpenTicketAddressCard
                                            dispatch={dispatch}
                                            form={form}
                                            cmd={cmd} />
                                    </Col>
                                    <Col sm={6}>
                                        <OpenTicketCallerCard
                                            dispatch={dispatch}
                                            form={form}
                                            cmd={cmd} />
                                    </Col>
                                </Row>
                            </div>
                            <div className={cx(style.visibility, {[style.visible]: wizard.matchActiveStep(2)})}>
                                <OpenTicketContactToCallbackCard
                                    dispatch={dispatch}
                                    form={form}
                                    cmd={cmd} />
                            </div>
                            <div className={cx(style.visibility, {[style.visible]: wizard.matchActiveStep(3)})}>
                                <div>
                                    <OpenTicketPurposeCard
                                        dispatch={dispatch}
                                        form={form}
                                        cmd={cmd} />
                                    <PhotoPreview photos={cmd && cmd.photos || []}/>
                                    <OpenTicketRequestCard
                                        dispatch={dispatch}
                                        form={form}
                                        cmd={cmd} />
                                </div>
                            </div>
                            {/*<div className={cx(style.visibility, {[style.visible]: wizard.matchActiveStep(4)})}>*/}
                            {/*    <OpenTicketResponseCard*/}
                            {/*        dispatch={dispatch}*/}
                            {/*        form={form}*/}
                            {/*        cmd={cmd} />*/}
                            {/*</div>*/}
                        </div>
                        <div className={style.side}>
                            <div className={cx(style.visibility, {[style.visible]: wizard.matchActiveStep([1, 3])})}>
                                <OpenTicketStreamCardLayout
                                    onSubmit={(e, a, c, t) => this._openReceiveCallModal(e, c, t)} />
                            </div>
                        </div>
                        <div className={style.toolbar}>
                            <LoaderButton
                                bsStyle='primary'
                                bsSize='large'
                                disabled={!form.isValid()}
                                onClick={() => form.validate() && (cmd.locationRef.patrimonyUid && stream.length > 0 && (this._openModal('ConfirmModal') || true) || this._sendCmd()) || dispatch(errorStatus(i18n.formInvalid))}>
                                <Icon icon='checkWhite' size='xs' />
                            </LoaderButton>
                            <Button
                                bsSize='large'
                                disabled={!wizard.hasPreviousStep()}
                                onClick={() => wizard.previousStep()}>
                                <span>{'<<'}</span>
                            </Button>
                            <Button
                                bsSize='large'
                                disabled={!wizard.hasNextStep() || !stepIsValid(form, wizard.majorActiveStep)}
                                onClick={() => wizard.nextStep()}>
                                <span>{'>>'}</span>
                            </Button>
                            <Button
                                bsSize='large'
                                onClick={this._close}>
                                <span>x</span>
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
                {opened && (
                    <div>
                        {!previousStepsAreValid(form,0) && (<OpenTicketCompanyModal onSubmit={this._close} />)}
                        <ReceiveCallModal
                            caller={activeCaller}
                            assignee={null}
                            ticket={activeTicket}
                            show={openedModal == 'ReceiveCallModal'}
                            onHide={this._closeModal} />
                        <Modal
                            className='modal-danger'
                            show={openedModal == 'ConfirmModal'}
                            onHide={this._closeModal}>
                            <Modal.Header>
                                <Modal.Title>{i18n.newTicket}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className={style.text}>
                                    {i18n.newTicketText.map((text, index) => (
                                        <p key={index}>{text}</p>
                                    ))}
                                </div>
                                <ButtonToolbar>
                                    <LoaderButton
                                        bsStyle='danger'
                                        bsSize='large'
                                        onClick={this._sendCmd}>
                                        {i18n.openTicket}
                                    </LoaderButton>
                                    <Button
                                        bsSize='large'
                                        onClick={this._closeModal}>
                                        {i18n.cancel}
                                    </Button>
                                </ButtonToolbar>
                            </Modal.Body>
                        </Modal>
                    </div>
                )}
            </div>
        )
    }
}

OpenTicketModal = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: OpenTicketCmd.selectSchema,
    action: OPEN_TICKET_CMD_UPDATED
})(OpenTicketModal)

OpenTicketModal = connectWizard({
    steps: [1, 2, 3]
})(OpenTicketModal)

OpenTicketModal = connect((state) => ({
    ui: state.ui,
    cmd: state.ticket.openTicketCmd,
    stream: state.ticket.minorStream
}))(OpenTicketModal)

export default OpenTicketModal


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketModal.js